import { render, staticRenderFns } from "./EbookForPublicLayout.vue?vue&type=template&id=f5548a58&scoped=true&"
import script from "./EbookForPublicLayout.vue?vue&type=script&lang=js&"
export * from "./EbookForPublicLayout.vue?vue&type=script&lang=js&"
import style0 from "./EbookForPublicLayout.vue?vue&type=style&index=0&id=f5548a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5548a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer,VMain,VRow})
